import httpManager from "@/app/shared/utils/httpManager";

export async function fetchDashboardByBase(baseId) {
  return await httpManager.get(`/entities/portfolios/bases/${baseId}/dashboard/`);
}
